import type { ReactNode } from 'react'

/**
 * Wraps UI that must appear only in dev builds. It does NOT gate visibility —
 * the feature decides whether to render it (e.g. the seed-users list comes back
 * empty in prod). This is the safety net: a yellow/black hazard frame + a
 * "DEV ONLY" tag so that if such UI ever leaks to staging/prod it is impossible
 * to miss. Styling lives in `styles/index.css` (`.dev-fence`).
 */
export function DevOnly({
  label = 'Dev only',
  children,
}: {
  label?: string
  children: ReactNode
}) {
  return (
    <div className="dev-fence rounded-lg p-3">
      <span className="dev-fence-tag mb-2">{label}</span>
      {children}
    </div>
  )
}
